module.exports = __webpack_public_path__ + "static/media/NotiDropdown.69697aed.svg";